/* Jersey flocking option (custom — added by arthur)
 * Ties a "flocage" card to the product form. When ticked + filled, a separate
 * 3 € flocking product is added to the cart before the theme adds the jersey.
 * Uses event delegation so it survives Focal's partial re-renders. */
(function () {
  if (window.__jflockInit) return;
  window.__jflockInit = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function boxFor(form) {
    // NB: use getAttribute('id') — a product <form> has <input name="id"> which
    // shadows form.id via named form-control access (Focal relies on this too).
    var fid = form && form.getAttribute && form.getAttribute('id');
    if (!fid) return null;
    var boxes = document.querySelectorAll('.jflock');
    for (var i = 0; i < boxes.length; i++) {
      if (boxes[i].getAttribute('data-form-id') === fid) return boxes[i];
    }
    return null;
  }

  function updatePreview(box) {
    var nameEl = box.querySelector('[data-jflock-name]');
    var numEl = box.querySelector('[data-jflock-number]');
    var name = (nameEl.value || '').trim().toUpperCase();
    var num = (numEl.value || '').trim();
    box.querySelector('[data-jflock-pv-name]').textContent = name || box.getAttribute('data-ex-name');
    box.querySelector('[data-jflock-pv-number]').textContent = num || box.getAttribute('data-ex-num');
    box.classList.toggle('jflock--placeholder', !name && !num);
  }

  function injectHidden(form, name, num) {
    var prev = form.querySelectorAll('input[data-jflock-hidden]');
    for (var i = 0; i < prev.length; i++) prev[i].parentNode.removeChild(prev[i]);
    var summary = name;
    if (num) summary += (name ? ' ' : '') + 'n°' + num;
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'properties[_Flocage]';
    input.value = summary;
    input.setAttribute('data-jflock-hidden', '1');
    form.appendChild(input);
  }

  function clearHidden(form) {
    if (!form) return;
    var prev = form.querySelectorAll('input[data-jflock-hidden]');
    for (var i = 0; i < prev.length; i++) prev[i].parentNode.removeChild(prev[i]);
  }

  function addFlock(box, name, num) {
    var vid = parseInt(box.getAttribute('data-variant-id'), 10);
    var form = document.getElementById(box.getAttribute('data-form-id'));
    var qtyEl = form && form.querySelector('[name="quantity"]');
    var qty = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
    var props = {};
    if (name) props['Nom'] = name;
    if (num) props['Numéro'] = num;
    props['_maillot'] = box.getAttribute('data-product-title') || document.title;

    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: vid, quantity: qty, properties: props }] })
    }).then(function (res) {
      if (res.ok) return true;
      return res.json().then(function (j) {
        alert((j && j.description) || 'Impossible d’ajouter le flocage.');
        return false;
      });
    }).catch(function () {
      alert('Impossible d’ajouter le flocage. Réessaie.');
      return false;
    });
  }

  // Toggle: reveal + enable fields
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-jflock-toggle]')) return;
    var box = t.closest('.jflock');
    if (!box) return;
    var body = box.querySelector('[data-jflock-body]');
    var fields = box.querySelectorAll('[data-jflock-name],[data-jflock-number]');
    body.hidden = !t.checked;
    for (var i = 0; i < fields.length; i++) fields[i].disabled = !t.checked;
    if (t.checked) {
      updatePreview(box);
      var first = box.querySelector('[data-jflock-name]');
      if (first) first.focus();
    } else {
      box.querySelector('[data-jflock-error]').hidden = true;
      // drop any leftover flocking tag so an unchecked add stays clean
      clearHidden(document.getElementById(box.getAttribute('data-form-id')));
    }
  });

  // Live preview
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-jflock-name],[data-jflock-number]')) return;
    var box = t.closest('.jflock');
    if (box) updatePreview(box);
  });

  // Intercept add-to-cart in the capture phase (before Focal's product-form handler)
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    var box = boxFor(form);
    if (!box) return;
    var toggle = box.querySelector('[data-jflock-toggle]');
    if (!toggle || !toggle.checked) { clearHidden(form); return; }

    // Second pass: flocking already added, let the theme add the jersey.
    if (box.getAttribute('data-jflock-done') === '1') {
      box.removeAttribute('data-jflock-done');
      return;
    }

    var nameEl = box.querySelector('[data-jflock-name]');
    var numEl = box.querySelector('[data-jflock-number]');
    var name = (nameEl.value || '').trim();
    var num = (numEl.value || '').trim();
    var err = box.querySelector('[data-jflock-error]');

    if (!name && !num) {
      e.preventDefault();
      e.stopImmediatePropagation();
      err.hidden = false;
      nameEl.focus();
      return;
    }
    err.hidden = true;

    e.preventDefault();
    e.stopImmediatePropagation();

    addFlock(box, name, num).then(function (ok) {
      if (!ok) return;
      injectHidden(form, name, num);
      box.setAttribute('data-jflock-done', '1');
      if (form.requestSubmit) form.requestSubmit();
      else form.submit();
    });
  }, true);
})();
